import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import Routes from '../../routes';
import { MotorplayProvider } from '../../context';
import backgroundImage from '../../static/img/backgroundNew.jpg';


const App = ({ faviconURL, client, history, search, location, ...props }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.pathname]);

  useEffect(() => {
    // 'Loading' styles dynamically
    // TODO: Code splitting of scss files per client
    if (client) {
      document.body.className = client;
      // Adding client title
      const config = require(`../../../public/clients/${client}/config.json`);

      document.title = config.title;
    }
  }, [client]);

  useEffect(() => {
    const regex = /&one_time_token=[a-z0-9]+/;
    const searchWithoutOneTimeToken = search.replace(regex, '');
    history.replace(searchWithoutOneTimeToken);
  }, []);

  return (
    <MotorplayProvider>
   <div
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh', 
      }}
    >
        <Routes {...props} />
      </div>
    </MotorplayProvider>
  );
};

App.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  search: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  history: PropTypes.object,
  client: PropTypes.string.isRequired,
  faviconURL: PropTypes.string.isRequired,
};

export default App;
